<template>
  <div id="app">
    <header class="app-header" v-if="$route.path !== '/login'">
      <div class="header-container">
        <div class="header-logo">
          <router-link
            to="/"
            tag="a"
            aria-label="少儿英语"
            @click.native="rlogEvent('website_click_home')"
          ></router-link>
        </div>
        <ul class="header-tabs" role="navigation" aria-label="顶部导航">
          <!-- <router-link
            tag="li"
            active-class="is-active"
            to="/"
            @click.native="rlogEvent('website_click_home')"
            exact
          >
            <a>首页</a>
          </router-link>
          <router-link
            tag="li"
            active-class="is-active"
            to="/detail"
            @click.native="rlogEvent('website_click_course')"
          >
            <a>体验课程</a>
          </router-link>
          <router-link
            tag="li"
            active-class="is-active"
            to="/download"
            @click.native="rlogEvent('website_click_app')"
          >
            <a>APP下载</a>
          </router-link> -->
          <li>
            <a
              ref="wljb"
              href="http://www.12377.cn/"
              target="_blank"
              class="wljb"
              style="background-position: 0px 0px"
            ></a>
          </li>
        </ul>
      </div>
    </header>
    <transition name="fade" mode="out-in" v-if="!isUS">
      <router-view />
    </transition>
    <router-view v-else />
    <!-- <ad-pop /> -->
  </div>
</template>

<script>
// 广告弹框
// import AdPop from '@/website/components/AdPop'
export default {
  name: 'Web',
  components: {
    // 'ad-pop': AdPop
  },
  data() {
    return {
      bluebg: false,
      waitTimeOut: null,
      isUS: false
    }
  },
  created() {
    this.isUS = navigator.userAgent.indexOf('UCBrowser') > -1
  },
  watch: {
    $route(to, from) {
      if (to.path == '/detail' || to.path == '/download') {
        this.bluebg = true
        this.waitTimeOut && clearTimeout(this.waitTimeOut)
      }
      if (to.path == '/web' || to.path == '/') {
        this.bluebg = false
      }
    }
  },
  mounted() {
    var that = this
    this.waitTimeOut = setTimeout(function () {
      reportToRlog('website_home_wait')
      // _rlog.push(['_trackCustom', 'event', 'website_home_wait'])
      that.waitTimeOut = null
    }, 5)
    this.initHegui()
    // var tab = document.querySelector('.header-tabs li:nth-child(1)')
    // console.log(this.$route.path)
    // if (this.$route.path == '/')
    //   if (!tab.classList.contains('is-active')) tab.classList.add('is-active')
  },
  methods: {
    initHegui() {
      var wljb = this.$refs['wljb']
      wljb.setAttribute('href', 'http://www.12377.cn/')
      var tempPosition = -40
      window.setInterval(function () {
        wljb.style.cssText = 'background-position: 0px ' + tempPosition + 'px'
        if (tempPosition == -40) {
          wljb.setAttribute('href', 'http://www.12377.cn/node_548470.htm')
        } else if (tempPosition == -80) {
          wljb.setAttribute('href', 'http://gov.163.com/special/jiazhiguan/')
        } else {
          wljb.setAttribute('href', 'http://www.12377.cn/')
        }
        tempPosition = tempPosition - 40
        if (tempPosition == -160) {
          tempPosition = 0
        }
      }, 4e3)
    },
    rlogEvent(e) {
      // console.log(e)
      reportToRlog(e)
      // _rlog.push(['_trackCustom', 'event', e])
    },
    goDetail() {
      this.$router.push({
        path: '/detail'
      })
    },
    goHome() {
      this.$router.push({
        path: '/web'
      })
    },
    goDownload() {
      this.$router.push({
        path: '/download'
      })
    }
  }
}
</script>
<style></style>
<style scope>
.fade-enter-active {
  transition: opacity 0.2s ease-out;
}
.fade-leave-active {
  transition: opacity 0.2s ease-in;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#app {
  background-color: #fafbfc;
}
#app.bluebg {
  background-color: #fafbfc;
}
/* ::-webkit-scrollbar {
  display: none;
} */
.app-header {
  position: relative;
  z-index: 200;
  background-color: #fff;

  /* overflow-x: scroll; */
  /* min-width: 1191px; */
}
.header-container {
  position: relative;
  display: flex;
  max-width: 990px;
  min-height: 70px;
  /* padding: 0 100px; */
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 auto;
}
.header-logo a {
  display: inline-block;
  background: url(./assets/img/hlogo_2x.png) center no-repeat;
  width: 330px;
  height: 50px;
  background-size: 330px 50px;
  cursor: pointer;
  /* padding: 0 20px; */
}
.header-tabs {
  min-height: 43px;
  display: flex;
  padding: 0;
  margin: 0;
  /* margin-left: 40px; */
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #232842;
  flex-wrap: nowrap;
  line-height: 38px;
}
.header-tabs > li {
  /* vertical-align: middle; */
  padding: 0 20px;
  cursor: pointer;
  display: inline-block;
}
.header-tabs > li a {
  display: inline-block;
  position: relative;
  word-break: keep-all;
  white-space: nowrap;
}
.header-tabs > li a::after {
  position: absolute;
  width: 0;
  right: 0;
  left: 0;
  margin: auto;
  height: 3px;
  border-radius: 1.5px;
  background: #ffce24;
  content: '';
  bottom: 0px;
  transition: width 0.3s ease-out;
}
.header-tabs > li.is-active a::after {
  width: 55.55%;
}
</style>

<style>
@import '../assets/css/icon.css';
#app {
  width: 100%;
  height: 100%;
}
html,
body,
div,
p,
h1,
h2,
h3,
h4,
h5,
ol,
ul,
li,
dl,
dt,
dd,
form,
input,
textarea,
select,
span,
table,
tr,
td,
img {
  margin: 0;
  padding: 0;
  border: 0;
}
html,
body {
  background: rgba(255, 255, 255, 0.94);
  color: rgba(122, 122, 122, 1);
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Source Han Sans SC',
    'Noto Sans CJK SC', 'Helvetica Neue', sans-serif;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-font-smoothing: antialiased;
  font-size: 0.32rem;
  color: rgba(122, 122, 122, 1);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  -webkit-overflow-scrolling: touch; /* 解决ios滑动不流畅问题 */
}

body {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
*:focus,
*:hover {
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
:not(input, textarea) {
  -webkit-touch-callout: none;
  -webkit-user-select: element;
  user-select: element;
}
input,
textarea {
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
  -webkit-appearance: none;
}
input,
textarea {
  outline: none;
  border: none;
  border-radius: 0;
}
input::-moz-focus-inner,
input::-webkit-focus-inner,
input::focus-inner {
  border: 0;
}
textarea {
  resize: none;
}
ul,
ol,
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #333;
  outline: none;
}
a,
input {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
a:focus,
input:focus {
  outline: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}

div#trans-tooltip,
div#tip-left-top,
div#tip-top,
div#tip-right-top,
div#tip-right,
div#tip-right-bottom,
div#tip-bottom,
div#tip-left-bottom,
div#tip-left,
div#trans-content,
div#tip-arrow-bottom,
div#tip-arrow-top {
  display: none !important;
}

.wljb {
  display: block;
  background: url(https://shared.ydstatic.com/dict/v2016/entry/wljb.jpg)
    no-repeat;
  width: 130px;
  height: 40px;
  overflow: hidden;
}
</style>
